/**
 * The time zones of the countries Catalog bills in euros, each with its country.
 * Mirrors `euro_countries` in catalog-api's `config/markets.php`; every other
 * country is billed in `BILLING_CURRENCY`.
 */
export const EURO_TIME_ZONES: Readonly<Record<string, string>> = {
  'Europe/Vienna': 'AT',
  'Europe/Brussels': 'BE',
  'Europe/Sofia': 'BG',
  'Europe/Zagreb': 'HR',
  'Asia/Nicosia': 'CY',
  'Asia/Famagusta': 'CY',
  'Europe/Nicosia': 'CY',
  'Europe/Prague': 'CZ',
  'Europe/Copenhagen': 'DK',
  'Europe/Tallinn': 'EE',
  'Europe/Helsinki': 'FI',
  'Europe/Mariehamn': 'FI',
  'Europe/Paris': 'FR',
  'Europe/Berlin': 'DE',
  'Europe/Busingen': 'DE',
  'Europe/Athens': 'GR',
  'Europe/Budapest': 'HU',
  'Europe/Dublin': 'IE',
  'Europe/Rome': 'IT',
  'Europe/Riga': 'LV',
  'Europe/Vilnius': 'LT',
  'Europe/Luxembourg': 'LU',
  'Europe/Malta': 'MT',
  'Europe/Amsterdam': 'NL',
  'Europe/Warsaw': 'PL',
  'Europe/Lisbon': 'PT',
  'Atlantic/Azores': 'PT',
  'Atlantic/Madeira': 'PT',
  'Europe/Bucharest': 'RO',
  'Europe/Bratislava': 'SK',
  'Europe/Ljubljana': 'SI',
  'Europe/Madrid': 'ES',
  'Africa/Ceuta': 'ES',
  'Atlantic/Canary': 'ES',
  'Europe/Stockholm': 'SE',
  'Europe/London': 'GB',
  'Europe/Belfast': 'GB',
  'Europe/Zurich': 'CH',
  'Europe/Oslo': 'NO',
};

export const EUR_COUNTRIES: ReadonlySet<string> = new Set(Object.values(EURO_TIME_ZONES));

export const EUR_CURRENCY = 'EUR';
